import React from "react";
import { useTranslation } from "react-i18next";

interface BOMControlsProps {
  currency: string;
  onCurrencyChange: (currency: string) => void;
  showCosts: boolean;
  onShowCostsChange: (show: boolean) => void;
  buildingStyle: "lego" | "minecraft";
  onBuildingStyleChange: (style: "lego" | "minecraft") => void;
  onExport: () => void;
  onExportCsv: () => void;
  onExportBrickLinkCsv: () => void;
  onExportRebrickableCsv: () => void;
}

const BOMControls: React.FC<BOMControlsProps> = ({
  currency,
  onCurrencyChange,
  showCosts,
  onShowCostsChange,
  buildingStyle,
  onBuildingStyleChange,
  onExport,
  onExportCsv,
  onExportBrickLinkCsv,
  onExportRebrickableCsv,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bom-controls">
      <div className="control-group">
        <label htmlFor="building-style-select">
          {t("bom.buildingStyle")}:
        </label>
        <select
          id="building-style-select"
          value={buildingStyle}
          onChange={(e) => onBuildingStyleChange(e.target.value as "lego" | "minecraft")}
          className="style-select"
        >
          <option value="lego">LEGO</option>
          <option value="minecraft">Minecraft</option>
        </select>
      </div>

      <div className="control-group">
        <label htmlFor="currency-select">{t("bom.currency")}:</label>
        <select
          id="currency-select"
          value={currency}
          onChange={(e) => onCurrencyChange(e.target.value)}
          className="currency-select"
        >
          <option value="USD">USD ($)</option>
          <option value="EUR">EUR (€)</option>
          <option value="GBP">GBP (£)</option>
          <option value="JPY">JPY (¥)</option>
          <option value="CNY">CNY (¥)</option>
        </select>
      </div>

      <div className="control-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={showCosts}
            onChange={(e) => onShowCostsChange(e.target.checked)}
          />
          {t("bom.showCosts")}
        </label>
      </div>

      <button type="button" onClick={onExport} className="export-bom-btn">
        {t("bom.exportBOM")}
      </button>
      <button type="button" onClick={onExportCsv} className="export-bom-btn">
        {t("bom.exportCSV")}
      </button>
      <button
        type="button"
        onClick={onExportBrickLinkCsv}
        className="export-bom-btn"
      >
        {t("bom.exportBrickLink")}
      </button>
      <button
        type="button"
        onClick={onExportRebrickableCsv}
        className="export-bom-btn"
      >
        {t("bom.exportRebrickable")}
      </button>
    </div>
  );
};

export default BOMControls;
